// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");

function mapError(result, f) {
  if (result.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: result._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: Curry._1(f, result._0)
          };
  }
}

function mapError2(result, f) {
  if (result.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: result._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: Curry._1(f, result._0)
          };
  }
}

exports.mapError = mapError;
exports.mapError2 = mapError2;
/* No side effect */
